module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_yamanashi-20f2b88bb828830a3952c362690c0bd6.png";